<template>
  <button type="button" v-bind="$attrs" @click="show = true">
    <i class="bi bi-image" /> View screenshot
  </button>

  <ModalView v-model="show" title="Listing screenshot" size="lg" hide-footer>
    <PrivateEvidenceImage
      v-if="show"
      :city-id="cityId"
      :listing-id="listingId"
      :evidence="evidence"
    />
  </ModalView>
</template>

<script>
import ModalView from '@/components/common/ModalView.vue';
import PrivateEvidenceImage from './PrivateEvidenceImage.vue';

export default {
  inheritAttrs: false,
  components: {
    ModalView,
    PrivateEvidenceImage
  },
  props: {
    cityId: String,
    listingId: String,
    evidence: Object
  },
  data() {
    return {
      show: false
    };
  }
};
</script>
